export default "__VITE_ASSET__1zIRy_k8__"